export const CATALOG_PAGE_PATH = '/catalogue/';
export const SERVICES_PAGE_PATH = '/uslugi/';
export const APRO_PAGE_PATH = '/biznes/';
export const ROOMS_PAGE_PATH = '/rooms/';

export const B2B_PERSONAL_ACCOUNT_HOST = '/lkb2b/';

export const FAVORITE_DELIVERY_TYPE = {
  HOME_DELIVERY: 'HOME_DELIVERY',
  PICKUP: 'PICKUP',
  PICKUP_POINT: 'PICKUP_POINT',
  REGION: 'REGION',
} as const;

export const FAVORITE_DELIVERY_TYPES = [
  FAVORITE_DELIVERY_TYPE.HOME_DELIVERY,
  FAVORITE_DELIVERY_TYPE.PICKUP,
  FAVORITE_DELIVERY_TYPE.PICKUP_POINT,
  FAVORITE_DELIVERY_TYPE.REGION,
] as const;
